export default (value: string, max: number): boolean => value.length > max
